import React from 'react';

import { BillingTabs } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

export const BillingPage: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <BillingTabs />;
  }

  return (
    <DetailPageLayout titleContent="Billing">
      <BillingTabs />
    </DetailPageLayout>
  );
};
